import PortalIdParser from 'PortalIdParser';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { getV2EditorRoute, getV4EditorRoute } from '../utils/urlUtils';
import { getFormsV2RoutePrefix } from '../utils/getRoute';
import { FRAMEWORK_TABLE_PARAMS } from '../constants/queryParams';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/lib/RouteGenerators.ts#L47
 */
export function getDashboardRoute(tab = '', location = {
  search: ''
}) {
  return `${getFormsV2RoutePrefix()}/${tab}${location.search}`;
}

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/lib/RouteGenerators.ts#L236
 */
export function getPopupEditorRoute(guid, redirectUrl = getDashboardRoute()) {
  const portalId = PortalIdParser.get();
  const redirectQueryParam = redirectUrl ? `?redirectUrl=${encodeURIComponent(redirectUrl)}` : '';
  return `/lead-flows/${portalId}/edit/${guid}${redirectQueryParam}`;
}

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/utils/QueryParams.ts#L57
 */
export const getSearchParamsPrefix = params => params.toString() ? `?${params.toString()}` : '';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/utils/QueryParams.ts#L70
 */
export const getFilteredSearchParams = (currentSearchParams, paramsToRemove) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  paramsToRemove.forEach(param => searchParams.delete(param));
  return getSearchParamsPrefix(searchParams);
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/utils/QueryParams.ts#L60
 */
export const getUpdatedSearchParams = (currentSearchParams, key, value) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  searchParams.set(key, value);
  return getSearchParamsPrefix(searchParams);
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/lib/RouteGenerators.ts#L63
 */
export const getV2EditorRouteQueryString = ({
  redirectUrl
}) => {
  const search = window.location.search;
  const searchSanitized = getFilteredSearchParams(search, FRAMEWORK_TABLE_PARAMS);
  const queryString = redirectUrl ? getUpdatedSearchParams(searchSanitized, 'redirectUrl', redirectUrl) : searchSanitized;
  return queryString;
};
export const getRouteForEditAction = (formId, formType, isAlpha, redirectUrl) => {
  if (formType === FormTypes.FLOW) {
    return getPopupEditorRoute(formId, redirectUrl);
  } else if (isAlpha) {
    return getV4EditorRoute(formId);
  }
  return getV2EditorRoute(formId, undefined, redirectUrl);
};